export const CURRENT_DOMAIN = window.location.origin;

export const APP_MODE = import.meta.env.VITE_MODE;
export const IS_DEVELOPMENT = APP_MODE === 'development';
export const IS_PRODUCTION = APP_MODE === 'production';

// INFO: domain linked with the mobile app (Universal Links / App Links)
export const APP_LINKS_DOMAIN = IS_PRODUCTION
  ? 'https://fitfast.com'
  : 'https://dev.fitfast.com';

export const API_URL = import.meta.env.VITE_APP_BASE_URL_API;

export const FACEBOOK_LINK = import.meta.env.VITE_FACEBOOK_LINK;
export const INSTAGRAM_LINK = import.meta.env.VITE_INSTAGRAM_LINK;

export const STORE_LINK_IOS = import.meta.env.VITE_APP_STORE_LINK_IOS;
export const STORE_LINK_ANDROID = import.meta.env.VITE_APP_STORE_LINK_ANDROID;

export const PROGRESS_BAR_CHECK_ITEMS = 6;

export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL;
export const SUPPORT_URL = import.meta.env.VITE_SUPPORT_URL;

export const I18NEXUS_API_KEY = import.meta.env.VITE_I18NEXUS_API_KEY;

export const CHUNK_RELOAD_COOLDOWN = 10_000;
